var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForTheArtists(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 502.23 604.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#111;opacity:0.2;}.cls-3{fill:#eaeaea;}.cls-11,.cls-4{fill:#d9d9d9;}.cls-4{opacity:0.75;}.cls-10,.cls-14,.cls-5,.cls-8{fill:none;stroke-miterlimit:10;}.cls-10,.cls-14,.cls-5{stroke:#000;}.cls-10,.cls-5,.cls-8{stroke-linecap:round;}.cls-14,.cls-5,.cls-8{stroke-width:2px;}.cls-6{fill:#b7b7b7;}.cls-7{fill:#848484;}.cls-8{stroke:#fff;}.cls-9{fill:#444;opacity:0.25;}.cls-10{stroke-width:3px;}.cls-12{fill:#004fbd;}.cls-13{fill:#577ff1;}.cls-15{font-size:115.39px;font-family:GTAmerica-CondensedMedium, GT America;font-weight:500;letter-spacing:0.08em;}.cls-16{letter-spacing:0em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ForArtist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.64,566.39l83.69,7.38a359.63,359.63,0,0,0,219-51.28l59.16-36.11c29.87-18.23,30.42-61.41,1-80.4h0c-40.75-26.33-44-84.74-6.42-115.42h0a75.5,75.5,0,0,0,13.28-102.92l-23.7-32.54A416.21,416.21,0,0,0,253.82,3.62h0a75.5,75.5,0,0,0-98.34,67.69l-4.29,76.42A122.48,122.48,0,0,1,69.37,256.48l-16.73,5.86c-49,17.18-54.33,84.42-8.59,109.06h0a59.24,59.24,0,0,1,21.1,85.16h0C35.18,501.22,64.07,561.66,117.64,566.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325.34,92.13C241.5,42.32,132.76,70,83,153.85s-22.13,192.59,61.72,242.4a177,177,0,0,0,242.4-61.73C436.88,250.68,409.19,141.94,325.34,92.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.24,173.88a175.9,175.9,0,1,0-90.93,231.54A175.89,175.89,0,0,0,401.24,173.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.31,74.59,90.38,336.68a176.06,176.06,0,0,0,146.4,83.41l120.56-307A176.07,176.07,0,0,0,193.31,74.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M401.24,173.88a176.17,176.17,0,0,0-23.65-39.33L266.22,418.15a177.07,177.07,0,0,0,72.44-28.31L411.41,204.6A176.61,176.61,0,0,0,401.24,173.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.84,327.66A175.9,175.9,0,1,0,156.54,399,175.9,175.9,0,0,0,394.84,327.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.56,229.05a52.77,52.77,0,1,0-35.42,65.69A52.77,52.77,0,0,0,290.56,229.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M290.56,229.05a52.61,52.61,0,0,0-7.94-16L187.3,241.61a52.77,52.77,0,1,0,103.26-12.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 240.01,
    cy: 244.19,
    r: 42.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.36,241.68a5.28,5.28,0,1,1,2.14,7.15A5.28,5.28,0,0,1,235.36,241.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M336.85,150.1a135.6,135.6,0,0,0-71.47-38.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M310.44,175.76a98.55,98.55,0,0,0-52-28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M387.86,199.91A154.34,154.34,0,0,0,195.73,96.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.16,338.28a135.6,135.6,0,0,0,71.47,38.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M169.57,312.62a98.69,98.69,0,0,0,52,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.15,288.46A154.34,154.34,0,0,0,284.28,392"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.91,147.34a135.65,135.65,0,0,0-38.52,71.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.58,173.75a98.55,98.55,0,0,0-28,52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.36,131.84a117.26,117.26,0,0,0-78.7,146"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M334.1,341a135.59,135.59,0,0,0,38.52-71.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.44,314.62a98.69,98.69,0,0,0,28-52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M273.65,356.54a117.29,117.29,0,0,0,78.71-146"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.11,507.17l-5.63-4.61L200.23,262.37l-.35-.94L158.43,277l.35.94a14.37,14.37,0,1,1-26.91,10.11l-.35-.94L102.59,298l-28.12-23.1L46.36,309.09l.77.64a14.37,14.37,0,1,1-18.25,22.21l-.77-.64L0,365.51l100.78,82.81L70.9,484.84l-.63.77,29.64,24.25h0L215.37,604.3l.77.63,70.94-86.72,8.13-3.06-1.78-4.72,2-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.28,499,8.41,364.38l26.84-32.67A15.38,15.38,0,1,0,54.77,308l26.84-32.66,27.79,22.83-11,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.92,513.57l-39.58,14.87a15.37,15.37,0,1,0-28.78,10.81L193,554.12,98.36,302.27l39.58-14.87a15.37,15.37,0,0,0,28.78-10.81l39.58-14.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "135.93 402.25 139.07 410.63 153.35 393.18 147.35 388.28 135.93 402.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.28,499,8.41,364.38l26.84-32.67A15.38,15.38,0,1,0,54.77,308l26.84-32.66,27.79,22.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 89.44,
    y1: 411.06,
    x2: 123.61,
    y2: 369.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 190.18,
    y1: 382.73,
    x2: 236.14,
    y2: 505.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 145.19,
    y1: 383.21,
    x2: 224.35,
    y2: 353.47
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "151.04 442.5 110.72 409.37 106.82 414.12 155.37 454.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "141.13 416.11 119.67 398.48 115.77 403.23 145.46 427.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "108.09 328.16 92.75 315.56 88.85 320.31 112.62 339.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 181.5,
    y: 389.3,
    width: 6.15,
    height: 130.68,
    transform: "translate(-148.11 93.96) rotate(-20.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 194.69,
    y: 384.34,
    width: 6.15,
    height: 130.68,
    transform: "translate(-145.52 98.29) rotate(-20.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 238.67,
    y: 367.82,
    width: 6.15,
    height: 130.68,
    transform: "translate(-136.9 112.7) rotate(-20.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 180.21,
    y: 318.55,
    width: 39.26,
    height: 6.15,
    transform: "translate(-30.96 621.81) rotate(-110.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 225.47,
    y: 372.78,
    width: 6.15,
    height: 130.68,
    transform: "translate(-139.49 108.37) rotate(-20.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,343.38l-9.32-24.8a9.46,9.46,0,0,0-5.53,12.19l10,26.58a9.5,9.5,0,0,0,12.19,5.53l-4-10.64,7.07-2.66,4,10.64,5.35-2-4-10.64,7.08-2.66,4,10.64,5.34-2-4-10.64,7.13-2.68,4,10.65a9.5,9.5,0,0,0,5.53-12.19l-10-26.59a9.49,9.49,0,0,0-12.19-5.53l9.32,24.8L174.83,334l-9.31-24.8-5.3,2,9.32,24.8-7.13,2.68-9.32-24.8-5.3,2,9.32,24.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,374.29,53,357.33a9.55,9.55,0,0,0,1.32,13.44L76.4,389a9.58,9.58,0,0,0,13.44-1.32L81,380.35l4.84-5.89,8.86,7.28,3.66-4.45L89.48,370l4.84-5.89,8.86,7.28,3.66-4.45L98,359.67l4.87-5.94,8.86,7.28a9.57,9.57,0,0,0-1.31-13.43L88.26,329.39a9.57,9.57,0,0,0-13.43,1.32l20.64,17-4.87,5.94L70,336.64l-3.62,4.41L87,358,82.1,364,61.45,347l-3.62,4.41,20.65,17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "139.07 410.63 98.36 302.27 109.4 298.12 102.92 292.8 88.36 298.27 130.1 409.37 103.2 442.26 109.18 447.18 133.25 417.75 133.25 417.75 139.07 410.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M300.92,513.57l-39.58,14.87a15.37,15.37,0,1,0-28.78,10.81L193,554.12,98.36,302.27l39.58-14.87a15.37,15.37,0,0,0,28.78-10.81l39.58-14.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.28,499,8.41,364.38l26.84-32.67A15.38,15.38,0,1,0,54.77,308l26.84-32.66,27.79,22.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.02,
    y: 402.19,
    width: 124.3,
    height: 186.46,
    transform: "translate(-313.71 328.95) rotate(-50.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 128.04,
    y: 402.16,
    width: 124.3,
    height: 186.46,
    transform: "translate(-313.68 328.96) rotate(-50.72)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 107.54,
    y1: 508.08,
    x2: 186.24,
    y2: 411.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 169.51,
    y1: 542.71,
    x2: 232.47,
    y2: 465.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.46,
    cy: 448.17,
    r: 6.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1,548.17l8.34-10.2,28.13,17.66c3.66,2.3,6.07,4.08,8.6,6l.25-.3c-2.34-2.11-4.56-4.12-7.54-7.25L196,530l8.3-10.14L240,562.1l-10.34,12.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66,551.52l-42.12-34.45,8.1-9.9,42.12,34.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.27,485.13l3.44,2.82c7.9,6.45,8.57,14.34,1.88,22.52L254,513.68l15.36,12.56-8.1,9.91L219.11,501.7l10.53-12.87C236.53,480.4,243.87,479.18,251.27,485.13Zm-8.15,10.46c-3.38-2.76-5.62-2.81-7.71-.26l-1.55,1.9,13.29,10.87,1.55-1.9c2.09-2.55,1.42-4.88-2.56-8.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 135.55,
    y: 488.88,
    width: 99.44,
    height: 4.97,
    transform: "translate(-312.37 323.68) rotate(-50.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 117.91,
    y: 474.45,
    width: 99.44,
    height: 4.97,
    transform: "translate(-307.67 304.73) rotate(-50.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 109.09,
    y: 467.24,
    width: 99.44,
    height: 4.97,
    transform: "translate(-305.33 295.26) rotate(-50.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 126.73,
    y: 481.67,
    width: 99.44,
    height: 4.97,
    transform: "translate(-310.02 314.2) rotate(-50.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,444.56l-5.9,7.22-1.23-2.23a10.4,10.4,0,0,0-6-4.88h0a10.38,10.38,0,0,1-4.22-2.56l-14.34-14.33a2.41,2.41,0,0,1-.16-3.22h0a2.4,2.4,0,0,1,3.19-.48l16.89,11.21a10.33,10.33,0,0,1,3.35,3.63h0a10.37,10.37,0,0,0,6,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.72,574.18,483.5,558.59,456.6,241.46v-.08a32.71,32.71,0,0,0-22-27.87h0L422.3,209h0a32.47,32.47,0,0,0-15.24-2.39,33.33,33.33,0,0,0-5.62,1,32.86,32.86,0,0,0-9.13-5.36h0l-1-.37-.12,0-12.51-4.58h0a32.71,32.71,0,0,0-13.18-2.44,22.82,22.82,0,0,0-12.12-10.28v0S339,179.24,338.2,179a22.83,22.83,0,0,0-19.76,2.82L302.55,96.16a27.78,27.78,0,0,0-16.89-20.75h0l-.05,0c-.5-.2-1-.38-1.52-.56l-12.51-4.58h0a27.88,27.88,0,0,0-38.4,28.1L273.05,570l14.24,5.24h0l11.31-1,1.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M449.35,239.22v-.08a32.53,32.53,0,0,0-11.93-22.28l4.19-.35L429.3,212h0a32.47,32.47,0,0,0-15.24-2.39,32.93,32.93,0,0,0-12.89,3.84,32.7,32.7,0,0,0-5.47-6.75l.15,0c.25-.07,3.47-1.5,3.47-1.5l-13.64-5h0a32.6,32.6,0,0,0-24.77,0,22.82,22.82,0,0,0-4.08-9.87l1,.4,2.55-3.25s-14.34-5.28-15.19-5.55A22.9,22.9,0,0,0,320.68,189l-6.34,7.51-19-102.63a27.89,27.89,0,0,0-5.85-12.62l3.21-2.89-14.08-5.16h0a27.88,27.88,0,0,0-38.4,28.1L280.05,573l14.24,5.24,182.5-15.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M490.5,561.59,463.6,244.46v-.08a32.72,32.72,0,0,0-48.16-25.67,32.7,32.7,0,0,0-40.27-13.24,23,23,0,0,0-40.23-11.19l-6.34,7.51-19-102.63a27.85,27.85,0,0,0-55.13,7.42l39.87,471.66Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 452.18,
    y1: 245.43,
    x2: 479.07,
    y2: 562.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M321.74,227.69,298.28,101.25a16.39,16.39,0,0,0-17.49-13.34h0a16.38,16.38,0,0,0-14.94,17.71l39.87,471.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M369.92,427a76.66,76.66,0,0,1-82.87-69.91l-5.2-61.22a46,46,0,0,1,10.68-33.55l51.16-60.64a11.5,11.5,0,0,1,20.25,6.44l.33,3.93A76.69,76.69,0,0,1,346.48,268l-12.06,14.3a7.59,7.59,0,0,0,1.08,10.93,79.09,79.09,0,0,1,30.49,56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M373.94,278.32l-7.22-38.74a21.19,21.19,0,0,1,19-25h0a21.18,21.18,0,0,1,23,21.43l-.59,39.41a17.25,17.25,0,0,1-15.79,16.93h0A17.24,17.24,0,0,1,373.94,278.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363.77,228.86a21,21,0,0,1,2.73,10.74l-.59,39.4a17.25,17.25,0,0,1-15.79,16.93h0a17.24,17.24,0,0,1-17.33-10.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417.47,290l-7.23-38.74a21.2,21.2,0,0,1,19-25h0a21.19,21.19,0,0,1,23,21.43l-.59,39.41a17.25,17.25,0,0,1-15.79,16.93h0A17.24,17.24,0,0,1,417.47,290Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(333.66 547.07) rotate(-4.85)"
  }, "#", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 72.12,
    y: 0
  }, "1"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForTheArtists);
export default __webpack_public_path__ + "static/media/for_the_artists.f70520b6e88aedfb153efb29bd4d8022.svg";
export { ForwardRef as ReactComponent };